module.exports = __webpack_public_path__ + "img/logo-123.7bc13408.png";